import { State } from 'easy-peasy';
import { StoreState } from '../store/store';
import { VideoItem } from '../typings';

export function getAssetName(videoItem: VideoItem | null, storeState: State<StoreState>) {
  let assetName: string;

  // Handle video fetched from CocoAPI, which provides an specific asset name
  if (storeState.videos.data) {
    assetName = storeState.videos.data.videoAnalytics.assetName;
  } else {
    assetName = 'Unknown Title';
  }

  return assetName;
}

export function getCustomContentType(storeState: State<StoreState>) {
  return storeState.config.isBODi ? 'BODi' : 'BOD';
}
